<div class="cpcontent">
  <div class="d-flex justify-content-between align-items-start mb-4">
    <div>
      <h2 class="mb-2">Virtex Assets</h2>
      <h6 class="mb-0">📊 Total Files: {{ getTotalFileCount() }}</h6>
      <small class="text-muted">Across {{ folders.length }} folders</small>
    </div>
    <div class="mt-2">
      <button class="btn btn-outline-warning" (click)="checkConsistency()">
        <i class="bi bi-check-circle"></i> Check Consistency
      </button>
    </div>
  </div>
<div id="assetinfo" *ngIf="showAssetInfo" class="alert alert-info rounded-3 border-0 mb-4" style="background-color: #e6f3ff; border-left: 4px solid #0dcaf0 !important;">
  <!-- Collapsible Header -->
  <div class="d-flex justify-content-between align-items-center" style="cursor: pointer;" (click)="showInfoBox = !showInfoBox">
    <h6 class="alert-heading mb-0"><i class="bi bi-cloud-arrow-down me-2"></i>Virtex Asset Management</h6>
    <i [class]="showInfoBox ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
  </div>
  
  <!-- Collapsible Content -->
  <div *ngIf="showInfoBox">
  <div class="d-flex mt-3">
    <div class="me-3">
      <i class="bi bi-info-circle-fill text-info fs-4"></i>
    </div>
    <div>
      <p class="mb-2">
        Browse and manage Virtex scenario assets from AWS S3 bucket <code class="bg-light px-2 py-1 rounded">virtexassets</code>.
      </p>
      
      <p class="mb-0 small">
        <strong>📁 Folders:</strong> meta/ (preview images) • assets/ (GLB models) • sources/ (original files)<br>
        <strong>🔍 Features:</strong> Search, image previews, consistency checking, file size monitoring
      </p>
    </div>
  </div>
  </div>
</div>

<!-- Consistency Check Results Box -->
<div id="consistencyResults" *ngIf="showConsistencyResults && consistencyResults" class="alert alert-warning rounded-3 border-0 mb-4" style="background-color: #fff3cd; border-left: 4px solid #ffc107 !important;">
  <!-- Collapsible Header -->
  <div class="d-flex justify-content-between align-items-center" style="cursor: pointer;" (click)="showConsistencyResults = !showConsistencyResults">
    <h6 class="alert-heading mb-0"><i class="bi bi-check-circle me-2"></i>Consistency Check Results</h6>
    <i class="bi bi-x-lg" (click)="showConsistencyResults = false; $event.stopPropagation()"></i>
  </div>
  
  <!-- Content -->
  <div class="mt-3">
    <div class="row mb-3">
      <div class="col-6">
        <strong>📊 Total GLB files:</strong> {{ consistencyResults.glbFileCount }}
      </div>
      <div class="col-6">
        <strong>🖼️ Total image files:</strong> {{ consistencyResults.metaFileCount }}
      </div>
    </div>
    
    <div class="row">
      <div class="col-6">
        <div class="bg-light p-2 rounded">
          <strong class="text-danger">⚠️ GLB files without images ({{ consistencyResults.glbWithoutImages.length }}):</strong>
          <div *ngIf="consistencyResults.glbWithoutImages.length > 0" class="mt-2" style="max-height: 300px; overflow-y: auto;">
            <small class="d-block" *ngFor="let file of consistencyResults.glbWithoutImages">• {{ file }}</small>
          </div>
          <div *ngIf="consistencyResults.glbWithoutImages.length === 0" class="mt-2 text-success">
            <small>✓ All GLB files have corresponding images</small>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="bg-light p-2 rounded">
          <strong class="text-danger">⚠️ Images without GLB files ({{ consistencyResults.imagesWithoutGlb.length }}):</strong>
          <div *ngIf="consistencyResults.imagesWithoutGlb.length > 0" class="mt-2" style="max-height: 300px; overflow-y: auto;">
            <small class="d-block" *ngFor="let file of consistencyResults.imagesWithoutGlb">• {{ file }}</small>
          </div>
          <div *ngIf="consistencyResults.imagesWithoutGlb.length === 0" class="mt-2 text-success">
            <small>✓ All images have corresponding GLB files</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  <!-- Main content row -->
  <div class="row">
    <!-- Left side: Folders List -->
    <div class="col-9">
      <div class="mb-4">
        <h4>Available Folders in meta/:</h4>
        <div *ngIf="folders.length > 0" class="folder-list">
          <div *ngFor="let folder of folders" class="mb-2">
            <!-- Folder Header -->
            <div class="d-flex justify-content-between align-items-center mb-2 p-3 bg-light rounded">
              <div class="d-flex align-items-center">
                <button class="btn btn-sm btn-outline-primary me-2" (click)="toggleFolder(folder.name)">
                  <span *ngIf="!loadedFolders[folder.name]">
                    <i class="bi bi-download"></i> Load Files
                  </span>
                  <span *ngIf="loadedFolders[folder.name] && !isFolderExpanded(folder.name)">
                    <i class="bi bi-chevron-down"></i> Expand
                  </span>
                  <span *ngIf="loadedFolders[folder.name] && isFolderExpanded(folder.name)">
                    <i class="bi bi-chevron-up"></i> Collapse
                  </span>
                </button>
                <span class="text-primary me-2 fs-5">📁 {{ folder.name }}</span>
                <span class="badge bg-secondary">{{ folder.fileCount }}</span>
              </div>
              <div></div>
            </div>

            <!-- Files List (appears below folder header when expanded) -->
            <div *ngIf="isFolderExpanded(folder.name) && hasFiles(folder.name)" class="mt-4 mb-3">
              <div class="files-container p-2 border rounded bg-white">
                <div class="row g-3">
                  <div *ngFor="let file of folderFiles[folder.name]" class="col-md-2">
                    <div class="d-flex flex-column border rounded shadow-sm" style="height: 100%;">
                      <!-- Image thumbnail -->
                      <div style="width: 100%;">
                        <img *ngIf="isImageFile(file.Key) && file.DownloadUrl" 
                             [src]="file.DownloadUrl" 
                             [alt]="file.GLBFile" 
                             class="file-link" 
                             (click)="onFileClick(file)"
                             style="height: 200px; width: 100%; object-fit: cover; cursor: pointer; display: block;">
                      </div>
                      
                      <!-- File info below image -->
                      <div class="p-2" style="width: 100%;">
                        <div class="text-truncate mb-1" [title]="file.GLBFile">
                          <small><strong>{{ file.GLBFile }}</strong></small>
                        </div>
                        <div>
                          <small class="text-muted d-block">Image: {{ getSizeFormatted(file.Size) }}</small>
                          <small *ngIf="file.glbSize" class="text-muted d-block">GLB: {{ getSizeFormatted(file.glbSize) }}</small>
                          <small *ngIf="!file.glbSize" class="text-warning d-block">GLB: not found</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="folders.length === 0" class="text-muted">
          No folders found or still loading...
        </div>
      </div>
    </div>

    <!-- Right side: Search Functionality -->
    <div class="col-3">
      <div class="mb-4">
        <h4>Search Files</h4>
        <div class="d-flex mb-3">
          <input type="text" class="form-control me-2" placeholder="Enter search term..." [(ngModel)]="searchTerm">
          <button class="btn btn-primary" (click)="searchFiles()" [disabled]="searchLoading">
            <i class="bi bi-search"></i>
            <span *ngIf="!searchLoading">Search</span>
            <span *ngIf="searchLoading">Searching...</span>
          </button>
        </div>

        <!-- Search Results -->
        <div *ngIf="searchResults.length > 0" class="mt-3">
          <h6>Search Results ({{ searchResults.length }} files found):</h6>
          <div class="files-container p-2 border rounded bg-white">
            <div class="file-list">
              <div *ngFor="let file of searchResults" class="border-bottom py-1">
                <small class="d-flex justify-content-between">
                  <span class="text-truncate me-2 file-link" (click)="onFileClick(file)" [class.clickable-file]="isImageFile(file.Key)" [title]="isImageFile(file.Key) ? 'Click to preview image' : ''">
                    <span class="text-muted me-1">[{{ file['FolderName'] }}]</span>{{ file.GLBFile }}
                  </span>
                  <span class="text-muted">({{ getSizeFormatted(file.Size) }})</span>
                </small>
              </div>
            </div>
          </div>
        </div>

        <!-- No results message -->
        <div *ngIf="searchPerformed && searchResults.length === 0 && !searchLoading" class="mt-3">
          <div class="alert alert-info">
            No files found containing "{{ searchTerm }}"
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Disabled old Collapsible Sections - using folder-based approach now -->
  <!-- 
  <div *ngFor="let section of fileSections">
    <h5 (click)="toggleSection(section.key)" class="collapsible-header">
      {{ section.label }}
      <span [class]="collapsedSections[section.key] ? 'arrow-down' : 'arrow-up'"></span>
    </h5>
    <div *ngIf="!collapsedSections[section.key]" class="file-container">
      <div *ngFor="let obj of section.files" class="file-item">
        <img *ngIf="obj.CanPreview" [src]="obj.DownloadUrl" alt="Image">
        <div *ngIf="!obj.CanPreview" class="placeholder"></div>
        <div class="file-name">{{ obj.GLBFile }} ({{obj.Size | number:'1.0-0'}} KB)</div>
      </div>
    </div>
  </div>
  -->
</div>

<!-- File Preview Modal -->
<div class="modal fade" [class.show]="showFileModal" [style.display]="showFileModal ? 'block' : 'none'" tabindex="-1" role="dialog" aria-labelledby="fileModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content" style="border-radius: 6px;">
      <div class="modal-header" style="background-color: rgb(4, 73, 15); color: white; padding: 10px; margin: 0; border-top-left-radius: 6px; border-top-right-radius: 6px; border-bottom: none;">
        <h5 class="modal-title" id="fileModalLabel" style="margin: 0; color: white;">{{ selectedFile?.GLBFile }}</h5>
        <button type="button" class="btn btn-light btn-sm" aria-label="Close" (click)="closeFileModal()">
          <i class="bi bi-x-lg"></i> Close
        </button>
      </div>
      <div class="modal-body text-center" style="padding: 20px; margin: 0; background-color: white;">
        <img *ngIf="selectedFile?.DownloadUrl" [src]="selectedFile!.DownloadUrl" [alt]="selectedFile!.GLBFile" class="img-fluid max-image-size">

        <!-- File size information -->
        <div class="mt-3">
          <div class="row justify-content-center">
            <div class="col-auto">
              <small class="text-muted">
                <strong>Image Size:</strong> {{ getSizeFormatted(selectedFile?.Size || 0) }}
              </small>
            </div>
            <div class="col-auto" *ngIf="selectedFileGlbSize !== null">
              <small class="text-muted">
                <strong>GLB Size:</strong> {{ getSizeFormatted(selectedFileGlbSize) }}
              </small>
            </div>
            <div class="col-auto" *ngIf="selectedFileGlbSize === null">
              <small class="text-warning">
                <strong>GLB:</strong> Not found
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal backdrop -->
<div *ngIf="showFileModal" class="modal-backdrop fade show" (click)="closeFileModal()"></div>